import React from 'react'
import { RowButton } from 'components/atoms'
import { productTableColumns } from 'domains/product'

const productCollectionAddItemTableColumns = ({
  selectedItems,
  handleClickAddItem
}) => {

  const isDisabled = (data) => {
    const isSelected = selectedItems.find((element) => element.sku === data.sku)

    if (isSelected) return true

    return false
  }

  // eslint-disable-next-line react/prop-types
  const ActionCell = ({ cell: { row } }) => (
    <RowButton
      // eslint-disable-next-line react/prop-types
      data={ row.original }
      className='w-100'
      color="primary"
      onClick={ handleClickAddItem }
      text="Add"
      // eslint-disable-next-line react/prop-types
      disabled={ isDisabled(row.original) }
    />
  )

  return (
    [
      ...productTableColumns(),
      {
        Header : 'Action',
        id     : 'action',
        Cell   : ActionCell
      }
    ]
  )
}

export default productCollectionAddItemTableColumns
